<template>
  <component v-if="viewPendenciaLogin !== null" :is="viewPendenciaLogin" :erros="errosAceiteContrato" @finalizandoPendencia="finalizandoPendencia" @enviarNotificacao="obterNotificacao">
  </component>
</template>

<script>
import * as authStorage from '@/modules/auth/storage'
import store from '../../store'
import constants from '@/util/constants'
import { mapState, mapActions } from 'vuex'
import util from '@/util'
import AlteracaoSenhaLoginLite from './AlteracaoSenhaLite.vue'
import AlertaVencimento from './AlertaVencimento.vue'
import AceiteContrato from './AceiteContrato.vue'
import PagamentoPendente from './PagamentoPendente.vue'
import OfertaBoasVindas from './OfertaBoasVindas.vue'

export default {
  name: 'pendenciasDeLogin',
  mounted () {
    try {
      this.restaurarDadosDaSessao()
    } catch (e) {
      console.log('Sessão inválida')
    }
  },
  computed: {
    ...mapState('auth', ['regrasLogin']),
    viewPendenciaLogin () {
      if (util.valorVazio(this.regrasLogin)) {
        return null
      }

      const pendenciasLogin = JSON.parse(this.regrasLogin)
      if (pendenciasLogin.deveAlterarSenha) {
        return AlteracaoSenhaLoginLite
      }

      if (pendenciasLogin.pendenteDeAceiteDeContrato) {
        return AceiteContrato
      }

      if (pendenciasLogin.ofertaBoasVindasPendente) {
        return OfertaBoasVindas
      }

      if (pendenciasLogin.alertarSobreVencido) {
        return AlertaVencimento
      }

      if (pendenciasLogin.pagamentoPendente) {
        return PagamentoPendente
      }

      return null
    }
  },
  data: () => {
    return {
      errosAceiteContrato: {}
    }
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),

    async finalizandoPendencia (callback, efetuarAutenticacao = true) {
      if (!util.valorEhNulo(callback)) {
        const self = this
        callback(self)
      }
      if (!efetuarAutenticacao) {
        return
      }
      if (!this.existemPendencias()) {
        await this.autenticar()
      }
    },

    async autenticar () {
      try {
        const resposta = await this.axios.post('/manager/auth/usuario/logado')
        const dadosLogin = resposta.data
        if (dadosLogin.success) {
          this.ActionSignOut()
          window.open(dadosLogin.url_login, '_self')
        } else {
          throw new Error('Login mal sucedido')
        }
      } catch (e) {
        console.log(e)
      }
    },

    existemPendencias () {
      const pendenciasLogin = JSON.parse(this.regrasLogin)
      for (let indice in pendenciasLogin) {
        if (pendenciasLogin[indice] === true) {
          return true
        }
      }
      return false
    },

    restaurarDadosDaSessao () {
      this.restaurarDadoDaSessao(authStorage.getRegrasLogin(), 'auth/temRegrasLogin', 'auth/ActionSetRegrasLogin')
      this.restaurarDadoDaSessao(authStorage.getRepresentanteLegal(), 'auth/temRepresentanteLegal', 'auth/ActionSetRepresentanteLegal')
      this.restaurarDadoDaSessao(authStorage.getDadosAlertaVencimento(), 'auth/temDadosAlertaVencimento', 'auth/ActionSetDadosAlertaVencimento')
    },

    restaurarDadoDaSessao (dadoNoStorage, getter, mutation) {
      const temDadoNoState = store.getters[getter]
      if (temDadoNoState === false) {
        if (dadoNoStorage) {
          store.dispatch(mutation, dadoNoStorage)
        } else {
          store.dispatch('auth/ActionSignOut')
          this.$router.push({ name: constants.nomeRotaLoginLite }) // Rota provisório
          throw new Error('Sessão inválida')
        }
      }
    },

    obterNotificacao (listaDeErros, callbackNotificacao) {
      this.errosAceiteContrato = { ...listaDeErros }

      if (!util.valorEhNulo(callbackNotificacao)) {
        const self = this
        callbackNotificacao(self)
      }
    }
  }
}
</script>
